import { ADMINS_API, getData } from 'src/Utils';
import { useQuery } from 'react-query';
import { useMemo } from 'react';
import { sortAssignableUsersByLastName } from 'src/Utils/adminUsersService';
export var useAdminUserOptions = function () {
    var _a = useQuery([ADMINS_API], function () { return getData('/admin_users'); }, {
        refetchOnWindowFocus: false,
    }), data = _a.data, isLoading = _a.isLoading;
    var adminUserOptions = useMemo(function () {
        return (data === null || data === void 0 ? void 0 : data.admin_users) ? sortAssignableUsersByLastName(data.admin_users).map(function (adminUser) { return ({
            label: adminUser.first_name + " " + adminUser.last_name,
            value: adminUser.id,
        }); })
            : [];
    }, [data]);
    return { isLoading: isLoading, adminUserOptions: adminUserOptions };
};
